const state = {
  dialogVisible: false,
};
const mutations = {
  setDialogVisible(state, payload) {
    state.dialogVisible = payload;
  },
};
const actions = {
  onShow({commit}) {
    commit("setDialogVisible", true);
  },
  onHide({commit}) {
    commit("setDialogVisible", false);
  },
  setDialogVisible({commit},data){
    commit("setDialogVisible", data);
  }
};
export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
